import { select } from "d3-selection";

export default selector => {
  let data = [];

  const $ = () => {
    const selection = select(selector);

    const steps = selection.selectAll(".homeSteps").data(data, function(d) {
      return d.step;
    });

    steps
      .enter()
      .append("div")
      .attr("class", function(d) {
        return `step vh-100 w-100 homeSteps with-navbar`;
      })
      .style("background-image", function(d) {
        return `url(${d.img_url})`;
      })
      .append("div")
      .attr("class", "container h-100")
      .append("div")
      .attr("class", "row h-100 align-items-center justify-content-center")
      .append("div")
      .attr("class", "col-11")
      .append("p")
      .attr("class", "text-center text-step")
      .html(function(d) {
        return d.text;
      });

    steps.merge(steps);

    steps.exit().remove();
  };

  $.data = _ => {
    data = _;
    return $;
  };

  return $;
};
